<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row class="bradcrumb">
      <router-link :to="{ name: 'role-links' }" class="root">
        Dashboard
      </router-link>
      /
      <router-link :to="{ name: 'admin-master' }" class="root">
        Incomplete Forms
      </router-link>
      <span class="child">/ Unpaid</span> </v-row
    ><br />

    <v-card class="card">
      <v-app id="inspire" class>
        <v-card-title class="heading justify-center"
          >Incomplete Forms</v-card-title
        >
        <div style="margin-top: 10px; margin-left: 20px;">
          <v-row style="margin-top: 10px">
            
            <v-col>
                <label>Exam Date (YYYY-MM-DD)</label>
              <datetime aria-label="Select Date" format="YYYY-MM-DD" aria-placeholder="2000-01-01" width="300px" v-model="fromdate"></datetime>
            </v-col>
            <v-col style="margin-top: 30px">
            <v-autocomplete
                :items="ay_list"
                v-model="ay"
                item-value="id"
                item-text="name"
                label="Select Acadmic Year"
              ></v-autocomplete>
            </v-col>
            <v-col style="margin-top: 20px" >
              <v-btn class="mr-4 test searchbutton" @click="SearchForm">
                Fetch
              </v-btn>
              <div v-show="loading" class="spinner-border spinner-border-sm" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </v-col>
            <v-col style="margin-top: 20px">
              <v-btn
            @click="sendMail"
            v-if="selected.length > 0"
            style="background: rgb(1, 127, 152); color: white"
          >
            Send Mail
            <v-icon right>mdi-cloud-upload</v-icon>
          </v-btn>
            </v-col>
          </v-row>
          <!---h5>Selected: {{ selected }}</h5-->
          <template v-if="load == true">
            <v-data-table
              v-model="selected"
              @current-items="getFiltered"
              :headers="headers"
              :items="stud_list1"
              sort-by="ptype"
              class="elevation-1 nowrap"
              :search="search"
              show-select
              height="200px"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <!-- <download-excel class="mar" :data="filterArr" :fields="export_table_headers"
                                        worksheet="stud_list" name="StudentData.xls">
                                        <v-btn color="success" dark class="mb-2">
                                            Export<v-icon dark>mdi-file-excel</v-icon>
                                        </v-btn>
                                    </download-excel> -->
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                  <span style="width: 20px"></span>
                  <v-dialog v-model="dialog" max-width="500px">
                    <!-- <template v-slot:activator="{ on }">
                                            <v-btn class="button" v-on="on">
                                                <v-icon left dark>mdi-account-plus</v-icon>Add New Student
                                            </v-btn>
                                        </template> -->
                    <v-card>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model.trim="editedItem.application_number"
                                label="Registration No."
                                :hint="
                                  editedItem.registration_number != ''
                                    ? ''
                                    : 'Please enter Registration Number'
                                "
                                persistent-hint
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model.trim="editedItem.seat_number"
                                label="Seat No."
                                :hint="
                                  editedItem.seat_number != ''
                                    ? ''
                                    : 'Please enter Seat Number'
                                "
                                persistent-hint
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model.trim="editedItem.first_name"
                                label="First Name."
                                :hint="
                                  editedItem.first_name != ''
                                    ? ''
                                    : 'Please enter First Name'
                                "
                                persistent-hint
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model.trim="editedItem.last_name"
                                label="Last Name."
                                :hint="
                                  editedItem.last_name != ''
                                    ? ''
                                    : 'Please enter Last Name'
                                "
                                persistent-hint
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model.trim="editedItem.name"
                                label=" Full Name"
                                :hint="
                                  editedItem.name != ''
                                    ? ''
                                    : 'Please enter Student Name'
                                "
                                persistent-hint
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model.trim="editedItem.username"
                                label="Username"
                                :hint="
                                  editedItem.email != ''
                                    ? ''
                                    : 'Please enter username Id'
                                "
                                persistent-hint
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model.trim="editedItem.mobilenumber"
                                label="Mobile No."
                                :hint="
                                  editedItem.mobilenumber != ''
                                    ? ''
                                    : 'Please enter Mobile No.'
                                "
                                persistent-hint
                              ></v-text-field>
                            </v-col>

                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              v-if="editedIndex == -1"
                            >
                              <v-autocomplete
                                :items="program_list"
                                v-model="editedItem.program"
                                label="Select program "
                                :rules="[(v) => !!v || 'required']"
                                :hint="
                                  editedItem.program != ''
                                    ? ''
                                    : 'Please Select Program'
                                "
                                persistent-hint
                              ></v-autocomplete>
                            </v-col>

                            <v-col cols="12" v-if="editedIndex != -1"
                              >Program
                              <v-autocomplete
                                dense
                                v-model="editedItem.program"
                                :items="program_list"
                                item-value="id"
                                :hint="
                                  editedItem.program != ''
                                    ? ''
                                    : 'Please Select Program'
                                "
                                persistent-hint
                                :error="errorMsg.program ? true : false"
                                :error-messages="
                                  errorMsg.program ? 'Required' : ''
                                "
                              ></v-autocomplete>
                            </v-col>

                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              v-if="editedIndex == -1"
                            >
                             </v-col>

                            

                            <!--  <v-col cols="12">
                                                    <v-autocomplete v-model="editedItem.program" :readonly="editedIndex==-1?false:true" item-text="program" item-value="id" label="SelectProgram" persistent-hint  :filled="editedIndex==-1?false:true" :error="errorMsg.program?true:false" :error-messages="errorMsg.program?'Required':''" return-object single-line :items="program_list"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" v-if='editedIndex != -1'>Program 
                                                        <v-select dense v-model="editedItem.program" :items="program_list" item-value="id" persistent-hint  :error="errorMsg.program?true:false" :error-messages="errorMsg.program?'Required':''"></v-select>
                                                </v-col>
                                                 <v-col cols="12">
                                                    <v-autocomplete v-model="editedItem.department" :readonly="editedIndex==-1?false:true" item-text="department" item-value="id" label="Select Department" persistent-hint  :filled="editedIndex==-1?false:true" :error="errorMsg.department?true:false" :error-messages="errorMsg.department?'Required':''" return-object single-line :items="dept_list"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" v-if='editedIndex != -1'>department 
                                                        <v-select dense v-model="editedItem.department" :items="dept_list" item-value="id" persistent-hint  :error="errorMsg.department?true:false" :error-messages="errorMsg.department?'Required':''"></v-select>
                                                </v-col>  -->
                          </v-row>
                          <v-row dense>
                            <v-col cols="12">
                              <v-checkbox
                                dense
                                v-model="editedItem.isactive"
                                color="success"
                                label="Active?"
                              ></v-checkbox>
                            </v-col>
                            <v-col>
                              <input
                                type="hidden"
                                v-model="editedItem.id"
                                name="id"
                              />
                              <!--  <v-hidden v-model="editedItem.id" label="id"></v-hidden> -->
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <!-- <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                                        <v-btn color="primary darken-1" @click="save">Save</v-btn> -->
                        
                        
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
                <tr class="t-row">
                  <div>
                    <th class="d-flex">
                      <span v-for="header in headers" :key="header.text">
                        <span v-if="filters.hasOwnProperty(header.value)">
                          <v-autocomplete
                            class="mr-5"
                            flat
                            hide-details
                            small
                            dense
                            outlined
                            :label="header.text"
                            multiple
                            clearable
                            :items="columnValueList(header.value)"
                            v-model="filters[header.value]"
                          ></v-autocomplete>
                        </span>
                      </span>
                    </th>
                  </div>
                </tr>
              </template>
              <template v-slot:item.isactive="{ item }">
                <span v-if="item.isactive">
                  <v-icon color="success" class="mr-2"
                    >mdi-check-circle-outline</v-icon
                  >
                </span>
                <span v-else>
                  <v-icon color="error" class="mr-2"
                    >mdi-close-circle-outline</v-icon
                  >
                </span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-avatar size="33" class="edit-avatar">
                  <v-icon
                    color="rgb(1, 127, 152)"
                    size="18"
                    @click="editItem(item)"
                    >mdi-pencil</v-icon
                  >
                </v-avatar>
              </template>
            </v-data-table>
          </template>

        </div>
      </v-app>
    </v-card>
  </div>
</template>
 <script>
import axios from "axios";
import datetime from "vuejs-datetimepicker";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    components: {
            datetime,
        },
  data: () => ({
    errorMsg: {
      program: false,
    },
    loading:false,
    dialog_send: false,
    file: null,
    loading3: false,
    tempname: "",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    load: false,
    dialog: false,
    stud_list: null,
    programtype_list: null,
    lang_list: null,
    program_list: null,
    dept_list: null,
    org: null,
    StudRecord: "",
    endDate: null,
    startDate: null,
    searchData: null,
    export_table_headers: {
      "Application No.": "application_number",
      "Name": "name",
      "Form Status": "form_status",
      "Payment Status": "transaction_payment_transaction_status",
      "username": "username",
      "Mobile Number": "mobilenumber",
      "Program": "program",
      "Exam Date": "exam_date",
      "Exam Fees": "exam_fees",
      "Registration Date": "exam_date",
    },
    headers: [
      {
        text: "Application Number",
        value: "application_number",
      },
      {
        text: "Name",
        value: "name",
      },
      {
        text: "Program",
        value: "program",
      },
      {
        text: "Payment Status",
        value: "transaction_payment_transaction_status",
      },
      {
        text: "Form Status",
        value: "form_status",
      },
      {
        text: "Username",
        value: "username",
      },
      {
        text: "Mobile Number",
        value: "mobilenumber",
      },
      {
        text: "Exam Date",
        value: "exam_date",
      },
    ],
    filters: {
      application_number: [],
      name: [],
      seat_no: [],
      username: [],
      mobilenumber: [],
      program: [],
      academic_year: [],
      exam_date: [],
      exam_fees: [],
    },
    singleSelect: false,
    selected: [],
    ay:null,
    fromdate:null,

    ay_list: [],
    filterArr: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      program: "",
      isactive: false,
      application_number: "",
      name: "",
      application_number: "",
      username: "",
      mobilenumber: "",
    },
    defaultItem: {
      id: "",
      program: "",
      isactive: false,
      application_number: "",
      name: "",
      application_number: "",
      username: "",
      mobilenumber: "",
    },
  }),

  computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Student" : "Edit Student";
            },
            stud_list1() {
                return this.stud_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },

        },
        
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    /*axios
             .post("/AdminImport/importStudentHome")
             .then(res => {
                 if (res.data.msg == "200") {
                     this.stud_list = res.data.stud_list;
                     this.program_list = res.data.program_list;
                     this.dept_list = res.data.dept_list
                     this.load = true;
                 } else {}
             })
             .catch(error => {
                 window.console.log(error);
             });*/
    // this.loadData();
    this.getAy()
  },

  methods: {
    getAy() {
        axios
        .post("/home/getAy")
        .then((res) => {
         this.ay_list = res.data.academic_year
        })
        .catch(function () {
          console.log("FAILURE!!");
        })
        .finally(() => {
          this.output_load = false;

        });
    },
    sendMail() {
      this.loading = true;
      console.log("inside sendMail");
      console.log(this.selected);
      axios
        .post("/AdminImport/unpaidstudentlist", this.selected)
        .then((res) => {
          this.showSnackbar("#4caf50", "Email Sent to selected student(s)");
          console.log(res);
        })
        .catch(function () {
          console.log("FAILURE!!");
        })
        .finally(() => {
          this.loading = false;
          this.output_load = false;
        });
    },
    SearchForm(e) {
      if(this.ay == null) {
        this.showSnackbar("#FF0000", "Please select Academic Year");
      } else if(this.fromdate == null) {
        this.showSnackbar("#FF0000", "Please select Exam Date");
      } else {
        this.loading = true;
        let dataToBeSend = {
          ay: this.ay,
          fromdate: this.fromdate,
        };
      //   console.log("inside search method", dataToBeSend);
        axios
          .post("/home/getUnpaidFeesStudentList", dataToBeSend)
          .then((res) => {
            if (res.data.msg == "200") {
              this.stud_list = res.data.learnerApplication;
              this.load = true;
            } else {
            }
          })
          .catch(function () {
            console.log("FAILURE!!");
          })
          .finally(() => {
            this.output_load = false;
          });
          setInterval(() => {
            this.loading=false;
          }, 5000);
          e.preventDefault(); // Prevent page from reloading.
      }
    },
    getFiltered(e) {
      console.log(e);
      this.filterArr = e;
    },
    columnValueList(val) {
      return this.stud_list.map((d) => d[val]);
    },

    initializeErrorMsgFalse() {
      this.errorMsg.program = false;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    editItem(item) {
      this.editedIndex = this.stud_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.dialog_send = false;
      this.initializeErrorMsgFalse();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          //  console.log("edit.." + this.editedItem);

          axios
            .post("/AdminImport/editStudent", this.editedItem)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                Object.assign(
                  this.stud_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",

                  "Student Updated Successfully..."
                ); // show snackbar on success
                this.loadData();
              } else if (res.data.status.code == "NA") {
                this.showSnackbar("#b71c1c", " Student Already Present!!!"); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      } else {
        if (this.isValidated()) {
          axios
            .post("/AdminImport/saveStudent", this.editedItem)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                this.stud_list.push(this.editedItem);
                this.showSnackbar("#4caf50", " Student Added Successfully..."); // show snackbar on success
                this.loadData();
              } else if (res.data.status.code == "NA") {
                this.showSnackbar("#b71c1c", " Student Already Present!!!"); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.program) {
        return true;
      } else {
        if (!this.editedItem.program) {
          this.errorMsg.program = true;
        }
        return false;
      }
    },
  },
};
</script>

    <style scoped>
.searchbutton {
  margin-left: 25px;
  background: rgb(1, 127, 152);
  width: 77px;
  color: orangered;
  border-radius: 15px;
  height: 30px;
}

.downbtn {
  float: right;
}

.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}

.box {
  background-color: #add8e630;
  margin: 8px !important;
  padding: 8px;
}

.flex {
  display: flex;
  justify-content: space-between;
}

@media only screen and (max-width: 600px) {
  .flex {
    display: block;
  }
}
</style>
    